import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions.js'
import mutations from './mutations.js'
import ChatService from "@/services/ChatService";
import WebsiteService from "@/services/WebsiteService";

import createPersistedState from "vuex-persistedstate";


Vue.use(Vuex)
const store = new Vuex.Store({

    state: {
        id: null,
        token: null,
        language: null,
        /**
         * Thread state
         */
        state: 2,
        policy_url: "",

        /**
         * Last message id
         */
        lastId: 0,
        agent: {
            name: null,
            isWritting: false
        },

        user: {
            name: null,
            email: null,
            isWritting: false
        },

        system: {
            name: "System",
            isWritting: false
        },

        chatWindowStatuses: {
            initial: 1,
            waiting: 2,
            active: 3,
            inactive_group: 4,
        },

        cartInfo: {
            "token": null,
            "share_url": null,
            "quantity_items": 0
        },

        waitingList: 0,
        isChatOpened: false,
        chatWindowStatus: 1,
        thread_state: 'closed',
        chatType: null,
        chatTypes: [],
        bounce: false,
        hasBounced: false,
        messages: [],
        printedMessages:{},
        hasNewMessages: false
    },
    mutations,
    actions,
    getters: {
        messages: state => {
            return state.messages
        },
        isUserLogged: state => {
            return state.user.name ? true : false
        },
        chatWindowStatusType: state => {
            return Object.keys(state.chatWindowStatuses).find(key => state.chatWindowStatuses[key] === state.chatWindowStatus);
        },
        policyUrl: state => {
            return state.policy_url;
        },
        threadState: state => {
            return state.thread_state;
        },
        shareCartAvailable: state => {
            //return false; // temporary disabled
            return state.cartInfo.quantity_items > 0 && state.cartInfo.token
        },
        cartInfo: state => {
            return state.cartInfo;
        },
        hasNewMessages: state => {
            return state.hasNewMessages;
        }
    },
    plugins: [createPersistedState()]
})

store.http = new ChatService(store);
store.websiteService = new WebsiteService(store);

export default store